<template>
    <div class="main-footer">
      <div class="copyrights">
        <div class="container">
          <div class="row">
            <div class="col-md-7">
              <p>© 2019 Mineables</p>
            </div>
            <div class="col-md-5 text-right">
            </div>
          </div>
        </div>
      </div>
    </div>
        <!-- <div class="mdl-mini-footer__left-section">
        <div class="mdl-logo">Mineables</div>
        <ul class="mdl-mini-footer__link-list">
            <li><a href="#">Help</a></li>
            <li><a href="#">Privacy & Terms</a></li>
        </ul>
        </div>
    </footer> -->
</template>

<script>

export default {
  name: 'xFooter'
}

</script>

<style>
footer.main-footer {
    padding: 30px 0 0;
    overflow-x: hidden;
    background: #5989e5;
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue